import { peso } from "@/lib/api";
import { BrandLogo } from "@/components/BrandLogo";
import { Badge } from "@/components/ui/badge";

export const STATUS_LABELS = {
  received: "Order Received", confirmed: "Order Confirmed", preparing: "Preparing / Heating",
  packing: "Packing", ready: "Ready for Pickup / Delivery", out_for_delivery: "Out for Delivery",
  delivered: "Delivered", completed: "Completed", cancelled: "Cancelled",
  refunded: "Refunded", failed: "Failed", on_hold: "On Hold",
};

export const STATUS_COLORS = {
  received: "#0284C7", confirmed: "#0284C7", preparing: "#EAB308", packing: "#F97316",
  ready: "#10B981", out_for_delivery: "#8B5CF6", delivered: "#16A34A", completed: "#16A34A",
  cancelled: "#EF4444", refunded: "#EF4444", failed: "#EF4444", on_hold: "#6B7280",
};

export function fmtAddress(a) {
  if (!a) return "";
  const parts = [];
  if (a.block) parts.push(`Block ${a.block}`);
  if (a.lot) parts.push(`Lot ${a.lot}`);
  if (a.phase) parts.push(`Phase ${a.phase}`);
  const line1 = parts.join(", ");
  return [line1, a.street, a.subdivision, `Brgy. ${a.barangay}`, `${a.city}, ${a.province}`].filter(Boolean).join(", ");
}

export function OrderTicket({ order }) {
  const d = new Date(order.created_at);
  return (
    <div className="bg-white rounded-2xl border shadow-sm overflow-hidden" data-testid="order-ticket">
      <div className="bg-[#1B5E20] text-white p-5 flex items-center justify-between">
        <BrandLogo size="sm" light />
        <Badge style={{ background: STATUS_COLORS[order.status] }} className="text-white font-semibold">{STATUS_LABELS[order.status]}</Badge>
      </div>
      <div className="p-5">
        <div className="flex justify-between items-start border-b border-dashed pb-4">
          <div>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Order Number</div>
            <div className="font-display font-extrabold text-xl text-[#1B5E20]" data-testid="ticket-order-number">{order.order_number}</div>
          </div>
          <div className="text-right text-sm">
            <div>{d.toLocaleDateString()}</div>
            <div className="text-muted-foreground">{d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 py-4 text-sm border-b border-dashed">
          <div><div className="text-muted-foreground text-xs">Customer</div><div className="font-medium">{order.contact_name}</div></div>
          <div><div className="text-muted-foreground text-xs">Contact</div><div className="font-medium">{order.contact_phone}</div></div>
          <div><div className="text-muted-foreground text-xs">Type</div><div className="font-medium capitalize">{order.order_type}</div></div>
          <div><div className="text-muted-foreground text-xs">Payment</div><div className="font-medium uppercase">{order.payment_method}</div></div>
          {order.address && <div className="col-span-2"><div className="text-muted-foreground text-xs">Delivery Address</div><div className="font-medium">{fmtAddress(order.address)}</div></div>}
          {order.delivery_notes && <div className="col-span-2"><div className="text-muted-foreground text-xs">Notes</div><div className="font-medium">{order.delivery_notes}</div></div>}
        </div>
        <div className="py-4 space-y-2 border-b border-dashed">
          {order.items.map((i, idx) => (
            <div key={idx} className="flex justify-between text-sm" data-testid={`ticket-item-${idx}`}>
              <span>{i.quantity}× {i.name}</span>
              <span className="font-medium">{peso(i.line_total)}</span>
            </div>
          ))}
        </div>
        <div className="pt-4 space-y-1.5 text-sm">
          <div className="flex justify-between"><span className="text-muted-foreground">Subtotal</span><span>{peso(order.subtotal)}</span></div>
          <div className="flex justify-between"><span className="text-muted-foreground">Delivery Fee</span><span>{peso(order.delivery_fee)}</span></div>
          <div className="flex justify-between font-display font-extrabold text-lg text-[#1B5E20] pt-1"><span>TOTAL</span><span data-testid="ticket-total">{peso(order.grand_total)}</span></div>
        </div>
      </div>
    </div>
  );
}
